//-------------------------------------------------------------------------------------------------- Import
import { BrowserRouter, Routes } from 'react-router-dom';
import DefaultLayout from './components/DefaultLayout';
import { useKeycloak } from "keycloak-react-web";
import { useEffect, useState } from "react";
import { ConfigProvider, Spin } from "antd";
import { AppDispatch } from './stores/store';
import { useDispatch } from 'react-redux';
import { fillGeneralDataSlice } from './stores/slices/generalDataSlice';
import { jwtDecode } from 'jwt-decode';
import { ProgramRoutes } from './routes/Routes';

//-------------------------------------------------------------------------------------------------- App
function App() {

	const ScreenSwitcher = () => {
		const dispatch = useDispatch<AppDispatch>();
		const { keycloak, initialized } = useKeycloak();
		const [isLogged, setIsLogged] = useState<boolean>(false);

		useEffect(() => {
			let clientId;
			if (isLogged && keycloak.token) {
				const tokenDecode = jwtDecode<any>(keycloak.token);
				const sucursal = tokenDecode.sucursal as string;
				const suscriptor = tokenDecode.suscriptor as string;
				clientId = sucursal.padStart(3, "0") + suscriptor.padStart(7, "0");
				dispatch(fillGeneralDataSlice({ clientId: clientId }));
			}
		}, [isLogged, keycloak.token, dispatch]);

		useEffect(() => {
			if (initialized) {
				if (!keycloak.authenticated) {
					keycloak.login();
					setIsLogged(false);
				} else {
					setIsLogged(true);
				}
			}
		}, [initialized, keycloak]);

		return (
			<>
				{
					isLogged ? (
						<ConfigProvider
							theme={{
								token: {
									fontFamily: "Montserrat"
								}
							}}
						>
							<BrowserRouter>
								<DefaultLayout>
									<Routes>
										{ProgramRoutes.map(element => element)}
									</Routes>
								</DefaultLayout>
							</BrowserRouter>
						</ConfigProvider>
					) : (
						<div
							style={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								padding: "",
							}}
						>
							<Spin size="large" />
						</div>
					)
				}
			</>
		)
	};

	return (
		<ScreenSwitcher />
	);
};

//-------------------------------------------------------------------------------------------------- Exports
export default App;
